module.exports = __webpack_public_path__ + "img/580b538ed61b58d84a0204c22ff05157.png";